import axios from 'axios';
import {
  FETCH_AI_SETTINGS,
  UPDATE_AI_SETTINGS,
  SET_AI_SETTINGS_LOADING,
  SET_AI_SETTINGS_ERROR
} from './type';

const BASE_URL = process.env.REACT_APP_PORT;
const head = {
  headers: {
    'x-auth-token': localStorage.getItem('token')
  }
};

// GET: ai_sense & ai_listen
export const fetchAISettings = () => async dispatch => {
  dispatch({ type: SET_AI_SETTINGS_LOADING });
  try {
    const res = await axios.get(`${BASE_URL}/api/ai/ai-sense-listen`, head);
    dispatch({ type: FETCH_AI_SETTINGS, payload: res.data?.data || {} });
    return res.data?.data || {};
  } catch (err) {
    dispatch({ type: SET_AI_SETTINGS_ERROR, payload: err.message });
    return null;
  }
};

// PUT: update ai_sense / ai_listen (partial or both)
export const updateAISettings = (payload) => async dispatch => {
  // payload can be { ai_sense, ai_listen } with booleans
  dispatch({ type: SET_AI_SETTINGS_LOADING });
  try {
    const res = await axios.put(`${BASE_URL}/api/ai/ai-sense-listen`, payload, head);
    dispatch({ type: UPDATE_AI_SETTINGS, payload: res.data?.data || {} });
    return res.data?.data || {};
  } catch (err) {
    dispatch({ type: SET_AI_SETTINGS_ERROR, payload: err.message });
    return null;
  }
};
